<template>
  <div id="configuration" class="configuration">
    <div v-if="!showError && person">
      <h2>Welcome {{person.firstName}} {{person.lastName}} in group {{group.groupName}}</h2>
      <p>Please click Save button</p>
    </div>
    <div v-if="showError">{{error}}</div>
  </div>
</template>

<script src="https://unpkg.com/@microsoft/teams-js@1.3.7/dist/MicrosoftTeams.min.js"></script>
<script>
import api from '../api'

export default {
  name: 'Configuration',
  data () {
    return {
      person: null,
      group: null,
      showError: false,
      error: null
    }
  },
  created () {
    var vm = this
    microsoftTeams.initialize()
    microsoftTeams.authentication.authenticate({
      url: window.location.origin + "/simple-start",
      width: 600,
      height: 535,
      successCallback: function (result) {
        getUserInfo();
      },
      failureCallback: function (reason) {
        vm.showError = true
        vm.error = reason
      }
    })

    function getUserInfo() {
      api.getUserInfo().then(response => {
        if (response.error) {
          vm.showError = true
          vm.error = response.error
          return
        }
        vm.person = response.personData
        vm.group = response.groupData
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Configuration.vue